import { gql } from '__generated__'

export const MERGE_GUEST_SESSION = gql(`
  mutation mergeGuestSession {
    mergeGuestSession {
      alreadyClaimed
      roundsMigrated
      wins
      upDownAi {
        roundsMigrated
        wins
        scoreMigrated
        rankDaily
        rankWeekly
        rankAlltime
      }
    }
  }
`)
